<fcp-modal title="{{ modalTitle | translate }}" [size]="modalSize" [id]="modalId" [config]="modalConfig">
    <div fcp-modal-content class="select-store-modal-container">
        <form [formGroup]="selectStoreForm" class="select-store-modal-container-form">
            <div class="select-store-modal-container-form-store-dropdown-container">
                <div
                    *ngIf="storeDropdownInvalid"
                    class="select-store-modal-container-form-store-dropdown-container-alert"
                >
                    <fcp-alert type="critical" size="large">
                        {{ 'ORDER.SELECT_STORES.STORE_REQUIRED' | translate }}
                    </fcp-alert>
                </div>
                <label>{{ 'ORDER.SHOPPING_CART.STORE' | translate }}</label>
                <fcp-dropdown
                    [title]="'ORDER.SHOPPING_CART.STORE' | translate"
                    [items]="stores | async"
                    [formControlName]="isMulti ? 'stores' : 'store'"
                    [isMulti]="isMulti"
                >
                    <fcp-icon [icon]="['fal', 'store-alt']"></fcp-icon>
                </fcp-dropdown>
            </div>

            <div class="fc-chips" *ngFor="let store of selectedStores">
                <fcp-chip [item]="store" (onRemove)="onRemoveStore(store, $event)" [dismissible]="true"> </fcp-chip>
            </div>
        </form>
    </div>
    <div
        fcp-modal-actions
        class="fcp-modal-actions"
        [ngClass]="{ 'fcp-modal-actions--mobile': displayMode === DisplayMode.Mobile }"
    >
        <button fcp-outlined-button (click)="cancelSave()">
            {{ 'TEXT_CANCEL' | translate }}
        </button>
        <button fcp-button color="prominent" (click)="emitSelectedStore()">
            {{ 'ORDER.SELECT_SINGLE_STORE_MODAL.APPLY' | translate }}
        </button>
    </div>
</fcp-modal>
